// Ham paket tanı listesi.
//
// Sözleşme §4: "her paketi ham sakla — denetim/yeniden işleme sigortası".
// Entegrasyon sorunlarını çözmenin tek yolu ajanın GERÇEKTEN ne gönderdiğini
// görmek: sayfa tanınmadı mı, values boş mu geldi, kuyrukta mı bekledi.

import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { DrawerGovde } from '../../components/Drawer'
import { tr, trTarihSaat } from '../../lib/trFormat'
import { PAKET_TURU_ETIKET, PAKET_TURU_SINIF, yasMetni } from './bicim'
import { entegrasyon } from './api'

const ADET = 50

export default function PaketlerDrawer({ kaynakId }: { kaynakId?: string }) {
  const [acikId, setAcikId] = useState<string | null>(null)

  const { data: paketler = [], isLoading } = useQuery({
    queryKey: ['entegrasyon-paketler', kaynakId ?? 'tumu'],
    queryFn: () => entegrasyon.paketler(kaynakId, ADET),
  })

  // Gövde AÇILDIĞINDA isteniyor. Listeyle birlikte gelseydi 50 paketin
  // tamamının ham JSON'u (paket başına onlarca KB) her açılışta taşınırdı,
  // oysa kullanıcı tek bir tanesine bakıyor.
  const { data: govde, isFetching: govdeGeliyor } = useQuery({
    queryKey: ['entegrasyon-paket-govde', acikId],
    queryFn: () => entegrasyon.paketGovdesi(acikId!),
    enabled: acikId !== null,
    staleTime: 5 * 60_000,
  })

  return (
    <DrawerGovde>
      <div className="info-box">
        <div>
          Son {ADET} ham paket. <b>Kuyruklama</b> sütunu paketin diskte ne kadar
          beklediğini gösterir (gönderim − yakalama); büyük değerler kesinti sonrası
          boşalan kuyruğun işaretidir.
        </div>
      </div>

      {isLoading && <div className="insp-empty">Yükleniyor…</div>}
      {!isLoading && paketler.length === 0 && (
        <div className="insp-empty">Henüz paket gelmedi.</div>
      )}

      <div className="mini-list">
        {paketler.map((p) => (
          <div className="mini-li" key={p.id} style={{ flexWrap: 'wrap' }}>
            <span className="dt" style={{ width: 96 }}>{trTarihSaat(p.alinmaZamani)}</span>
            <span className={`badge ${PAKET_TURU_SINIF[p.tur]}`}>
              {PAKET_TURU_ETIKET[p.tur]}
            </span>
            <span className="blg">#{p.seq}</span>
            <span className="mi-sub">
              {p.sayfaKodu ?? '—'} · {tr(p.okumaSayisi, 0)} okuma
              {p.kuyruklamaSn !== null ? ` · kuyrukta ${yasMetni(p.kuyruklamaSn)}` : ''}
              {p.hata ? ` · ${p.hata}` : ''}
              {p.kareImzasi ? ` · kare ${p.kareImzasi}` : ''}
            </span>
            <button
              className="mini-btn"
              type="button"
              title={acikId === p.id ? 'Ham gövdeyi gizle' : 'Ham gövdeyi göster'}
              style={{ marginLeft: 'auto' }}
              onClick={() => setAcikId((a) => (a === p.id ? null : p.id))}
            >
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d={acikId === p.id ? 'm18 15-6-6-6 6' : 'm6 9 6 6 6-6'} />
              </svg>
            </button>
            {acikId === p.id && (
              <pre
                className="mono"
                style={{
                  flexBasis: '100%',
                  margin: '6px 0 2px',
                  padding: 8,
                  fontSize: 10,
                  lineHeight: 1.5,
                  background: 'var(--mist)',
                  border: '1px solid var(--line)',
                  borderRadius: 6,
                  maxHeight: 260,
                  overflow: 'auto',
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                }}
              >
                {govdeGeliyor && govde?.id !== p.id
                  ? 'Gövde alınıyor…'
                  : JSON.stringify(govde?.govde ?? null, null, 2)}
              </pre>
            )}
          </div>
        ))}
      </div>
    </DrawerGovde>
  )
}
